if (!customElements.get('jupityr-results-gallery')) {
  customElements.define('jupityr-results-gallery', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.stories = [...this.querySelectorAll('[data-result-story]')];
      this.index = Math.max(0, this.stories.findIndex(story => !story.hidden));
      this.mobile = matchMedia('(max-width: 749px)');
      this.track = this.querySelector('[data-result-track]');
      const layout = () => this.stories.forEach((story, i) => { story.hidden = !this.mobile.matches && i !== this.index; });
      this.mobile.addEventListener('change', layout, options);
      layout();
      this.track.addEventListener('scroll', () => {
        if (!this.mobile.matches) return;
        const left = this.track.getBoundingClientRect().left;
        this.index = this.stories.reduce((nearest, story, i) => Math.abs(story.getBoundingClientRect().left - left) < Math.abs(this.stories[nearest].getBoundingClientRect().left - left) ? i : nearest, 0);
      }, options);
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-result-next], [data-result-previous]');
        if (!button || !this.contains(button)) return;
        this.show(this.index + (button.hasAttribute('data-result-next') ? 1 : -1), button);
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.stories.findIndex(story => story.dataset.resultStory === event.detail.blockId);
        if (index >= 0) this.show(index);
      }, options);
    }
    show(index, previousButton) {
      if (!this.stories.length) return;
      this.index = (index + this.stories.length) % this.stories.length;
      this.stories.forEach((story, i) => { story.hidden = !this.mobile.matches && i !== this.index; });
      const current = this.stories[this.index];
      if (this.mobile.matches) this.track.scrollTo({left:current.offsetLeft - this.stories[0].offsetLeft, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      this.querySelector('[data-result-status]').textContent = `Story ${this.index + 1} of ${this.stories.length}: ${current.querySelector('.jupityr-results-gallery__copy h3').textContent}`;
      if (previousButton) current.querySelector(previousButton.hasAttribute('data-result-next') ? '[data-result-next]' : '[data-result-previous]').focus({ preventScroll: true });
    }
    disconnectedCallback() { this.events?.abort(); }
  });
}
